import { render, staticRenderFns } from "./OffsetHeading.vue?vue&type=template&id=09fe2b10&scoped=true&"
import script from "./OffsetHeading.vue?vue&type=script&lang=js&"
export * from "./OffsetHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe2b10",
  null
  
)

export default component.exports